export const TRANSLATIONS_ES = {
    welcome: 'Muy pronto',
    search: 'Buscar',
    stores: 'Tiendas',
    back: 'Volver',
    next: 'Siguiente',
    review: 'Revisar',
    filter: 'Filtro',
    country: 'País',
    socialReason: 'Razón social',
    countries: {
        ar: 'Argentina',
        br: 'Brasil',
        cl: 'Chile',
        co: 'Colombia',
        cr: 'Costa Rica',
        ec: 'Ecuador',
        mx: 'México',
        pe: 'Perú',
        uy: 'Uruguay',
    },
    menuGenerator: {
        title: 'Generador de menús',
        breadcrumbItems: { brandDevelopment: 'Brand Development', menuGenerator: 'Generador de menús' },
        notAllowed: 'no está habilitado para usar esta funcionalidad.',
        tabs: {
            generated: 'Menús generados',
            top10: 'Top 10',
        },
        table: {
            generated: {
                header: {
                    generated: 'Generaste {{number}} menús',
                    initial: 'Aún no has generado menús',
                },
                ia: {
                    pending: 'Generando',
                    error: 'Generación fallida',
                },
                columns: {
                    name: 'Nombre de restaurante',
                    createdAt: 'Creado',
                    actions: 'Acciones',
                },
                actions: {
                    search: 'Buscar',
                    generate: 'Generar nuevo menú',
                    copyLink: 'Copiar enlace',
                    view: 'Ver en Google Sheets',
                    delete: 'Eliminar',
                },
            },
            top10: {
                stats: {
                    label: {
                        rank: 'Tu Rango',
                        totalMenus: 'Menús generados',
                        totalMenusToday: 'Menús generados hoy',
                    },
                    values: {
                        rank: `{{rank}}° lugar`,
                        withoutRank: 'Sin rango',
                        totalMenus: '{{totalMenus}} menús',
                        totalMenusToday: '{{totalMenusToday}} menús',
                    },
                },
                columns: {
                    rank: 'Rango',
                    name: 'Nombre',
                    country: 'País',
                    lastMenuUpdated: 'Ultimo menú actualizado',
                    totalMenus: 'Menús generados',
                },
            },
            pagination: {
                rangeSeparatorText: 'de',
                rowsPerPageText: 'Filas por página',
                selectAllRowsItemText: 'Todos',
            },
            notification: {
                error: 'Se produjo un problema al cargar los datos. Inténtalo nuevamente.',
            },
        },
        sidebar: {
            form: {
                title: 'Generar menú',
                restaurantName: 'Nombre de restaurante',
                leadId: 'Lead ID',
                country: 'País',
                fileInput: {
                    label: 'Arrastra tu menú aquí o',
                    dropLabel: 'Libera tus archivos aquí',
                    successLabel: 'Subido exitosamente',
                    select: 'Selecciona archivos',
                    replace: 'Reemplazar archivos',
                    multiple: {
                        fileName: 'archivos_combinados',
                        success: 'Los archivos se han combinado en un PDF, puedes visualizarlo <a>aquí</a>',
                        error: 'Error al combinar archivos',
                    },
                    rules: {
                        label: {
                            formats: 'Formatos',
                            maxSize: 'Tamaño máximo',
                        },
                        invalid: {
                            formats: 'Este archivo no es un formato compatible.',
                            maxSize: 'Este archivo es muy grande.',
                        },
                    },
                },
                submit: 'Generar',
                notification: {
                    success: 'Menú "{{restaurantName}}" generadose correctamente',
                    error: 'La generación del menú "{{restaurantName}}" ha fallado. Por favor, inténtelo de nuevo.',
                },
            },
        },
    },
    commercialProcesses: {
        title: 'Procesos Comerciales',
        startProcess: 'Comenzar Proceso',
        filter: {
            state: 'Estado',
            processName: 'Proceso Comercial',
            email: 'Email Agente',
        },
        state: {
            active: 'Activo',
            completed: 'Completado',
            rejected: 'Rechazado',
            review: 'En revisión',
            canceled: 'Cancelado',
            error: 'Error',
        },
        table: {
            columns: {
                country: 'País',
                process: 'Proceso Comercial',
                agent: 'Agente',
                state: 'Estado',
                startDate: 'Fecha de creación',
                updateDate: 'Fecha de actualización',
                action: 'Acción',
            },
            empty: {
                label: 'No hay procesos comerciales',
                description: 'No se encontraron procesos comerciales para los filtros aplicados.',
            },
            error: {
                label: 'Error al cargar procesos',
                description: 'Ocurrió un error al cargar los procesos comerciales. Inténtalo nuevamente.',
            },
        },
    },
    commercialProcessesFinder: {
        title: 'Buscador',
        idType: 'Tipo de Documento',
        id: 'Documento',
        searchTitle: 'Buscar razón social',
        searchDescription: 'Ingrese el tipo y número de documento de la razón social para ver los procesos comerciales disponibles.',
        processesTitle: 'Procesos Comerciales',
        duration: 'Duración',
        minutes: 'minutos',
        documents: 'Documentos',
        startProcess: 'Iniciar Proceso',
        processNotAvailable: 'Proceso no disponible',
        found: 'Razón social encontrada',
        notification: {
            error: 'Se produjo un problema al cargar los datos. Inténtalo nuevamente.',
            notFound: 'No se encontraron procesos comerciales disponibles para el documento ingresado.',
        },
        reasons: {
            BUSINESS_NO_PAYMENT_REFERENCE: 'No se encontró referencia de pago',
            BUSINESS_ALREADY_IN_PROCESS: 'La razón social ya tiene un proceso comercial en curso',
            BUSINESS_MISSING_MANDATORY_DETAILS: 'Business no tiene todos los datos en pagos (legalrepresentativeemail, contactmail, billingmail, legalrepresentativename, legalrepresentativelastname, is_person)',
        },
        processes: {
            'bank-account-change': {
                title: 'Cambio de cuenta bancaria',
                description: 'Actualiza la información de la cuenta bancaria donde el aliado recibirá los pagos de sus ventas',
            },
            'social-reason-change': {
                title: 'Cambio de razón social',
                description: 'Cede el contrato actual de la razón social activa a otra',
            },
            'fiscal-information-change': {
                title: 'Cambio de información fiscal',
                description: 'Actualiza la información fiscal del aliado registrado en rappi',
            },
            'brand-name-change': {
                title: 'Cambio de nombre comercial',
                description: 'Actualiza el nombre de la marca registrada en rappi',
            },
            'legal-representative-change': {
                title: 'Cambio de representante legal',
                description: 'Actualiza la información del representante legal  de la razón social',
            },
        },
    },
    commercialProcess: {
        titleNew: 'Nuevo Proceso Comercial',
        title: 'Proceso Comercial',
        exitConfirmation: '¿Estás seguro de que quieres salir? Se perderán todos los datos del proceso.',
        rejectionReason: 'Motivo del rechazo',
        breadcrumb: {
            processes: 'Procesos Comerciales',
            process: 'Proceso Comercial',
        },
        modal: {
            title: '¿Estás seguro de que quieres enviar estos cambios?',
            body: 'Recuerda que puedes volver a cualquier paso anterior para modificar la información sin perder el progreso realizado.',
            buttons: {
                cancel: 'Cancelar',
                continue: 'Continuar',
            },
        },
        notification: {
            getContext: {
                error: 'Se produjo un problema al obtener los datos del proceso. Inténtalo nuevamente.',
                notFound: 'No se encontraron datos del proceso.',
            },
            create: {
                success: 'Proceso creado correctamente',
                error: 'Se produjo un problema al crear el proceso. Inténtalo nuevamente.',
            },
            update: {
                success: 'Proceso actualizado correctamente',
                error: 'Se produjo un problema al actualizar el proceso. Inténtalo nuevamente.',
            },
        },
        steps: {
            'select-bank-account': {
                title: 'Selección de Cuenta Bancaria',
                description: 'Selecciona la cuenta bancaria cuyos datos deseas modificar',
                labels: {
                    bank: 'Banco',
                },
            },
            'bank-account-modification': {
                title: 'Formulario de Cuenta Bancaria',
                description: 'Por favor, ingresa los siguientes datos para continuar con el proceso.',
                scrapingData: 'Hemos identificado los siguientes datos en el certificado bancario',
            },
            'social-reason-modification': {
                title: 'Formulario de Razón Social',
                description: 'Por favor, ingresa los siguientes datos para continuar con el proceso.',
                scrapingData: 'Hemos identificado los siguientes datos en la razón social',
            },
            confirm: {
                title: 'Confirmación de Datos',
                description: 'Por favor, confirma los siguientes datos para crear el proceso',
                reviewTitle: '¡Revisión del proceso!',
                lastStepTitle: '¡Último paso!',
                reviewDescription: 'Estás visualizando la información de este proceso comercial en modo solo lectura. No puedes realizar cambios, pero puedes revisar todos los datos y documentos asociados.',
                lastStepDescription: 'Revisa cuidadosamente toda la información antes de continuar. Puedes retroceder a cualquier paso anterior para modificar los datos sin perder el progreso realizado.',
                close: 'Cerrar',
                finish: 'Finalizar proceso',
            },
            documents: {
                title: 'Documentos',
                description: 'Sube los siguientes documentos para continuar con el proceso. Asegúrate de que los archivos sean legibles.',
                labels: {
                    BANK_ACCOUNT: 'Certificado Bancario',
                    SOCIAL_REASON: 'Razón Social',
                },
            },
        },
    },
};
